<template>
  <div>
    <div class="agg-farmers__body__body__single borderBottom">
        <div class="row px-4">
        <div class="col-3 col-lg-3 py-3">
            <div class="row">
            <div class="col-lg-3">
                <div class="avatar">
                    
                    <img :src="farm.farm.owner.avatar" v-if="farm.farm.owner && farm.farm.owner.avatar" />
                    <span v-else class="font-bold color__white">
                        {{farm.farm.farmer_name | initials}}
                    </span>
                </div>
            </div>
            <div class="col-lg-9">
                <p class="font-bold">{{farm.farm.farmer_name}}</p>
                <small class="smallFont">{{farm.farm.city}}, {{getState ? getState.name : ''}}</small>
            </div>
            </div>

        </div>
        <div class="col-2 col-lg-2 py-3 d-flex align-items-center">
           {{ (farm.kg_yield - farm.kg_sold) / 1000 | formatNumber }} tons 
        </div>
        <div class="col-2 col-lg-2 py-3 d-flex align-items-center">
            <span class="naira mr-1"></span> {{farm.agg_kg_price / 0.001 | formatAmount }}
        </div>
        <div class="col-2 col-lg-2 py-3 d-flex align-items-center">
            Pre-planting
        </div>
        <div class="col-3 col-lg-3 d-flex align-items-center">
            <button class="btn btn-secondary-outline btn-sm" @click="linkToDetails">Details</button>
            <submit-button type="button" class="btn btn-secondary btn-sm" :disabled="checkKg"
            @click="addToCart">
            <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                d="M6.00407 13.1685H17.0241C18.2737 13.1685 19.293 12.1491 19.293 10.8995V6.26299C19.293 6.25888 19.293 6.25066 19.293 6.24654C19.293 6.23421 19.293 6.22599 19.293 6.21366C19.293 6.20544 19.293 6.19722 19.2889 6.189C19.2889 6.18078 19.2848 6.16845 19.2848 6.16023C19.2848 6.15201 19.2807 6.14378 19.2807 6.13556C19.2766 6.12734 19.2766 6.11912 19.2725 6.10679C19.2684 6.09857 19.2684 6.09035 19.2643 6.08213C19.2602 6.07391 19.2602 6.06569 19.256 6.05747C19.2519 6.04925 19.2478 6.04102 19.2437 6.02869C19.2396 6.02047 19.2355 6.01225 19.2314 6.00814C19.2273 5.99992 19.2232 5.9917 19.2191 5.98348C19.2149 5.97526 19.2108 5.97115 19.2067 5.96293C19.2026 5.95471 19.1944 5.94648 19.1903 5.93826C19.1862 5.93004 19.1821 5.92593 19.1738 5.91771C19.1697 5.90949 19.1615 5.90538 19.1574 5.89716C19.1533 5.88894 19.1451 5.88483 19.141 5.87661C19.1368 5.86839 19.1286 5.86428 19.1245 5.86017C19.1163 5.85195 19.1122 5.84784 19.104 5.83961C19.0957 5.8355 19.0916 5.82728 19.0834 5.82317C19.0752 5.81906 19.067 5.81084 19.0587 5.80673C19.0505 5.80262 19.0464 5.79851 19.0382 5.7944C19.03 5.79029 19.0218 5.78618 19.0135 5.77796C19.0053 5.77385 18.9971 5.76974 18.9889 5.76563C18.9806 5.76152 18.9724 5.75741 18.9642 5.7533C18.956 5.74919 18.9478 5.74508 18.9395 5.74096C18.9313 5.73685 18.9231 5.73685 18.9149 5.73274C18.9067 5.72863 18.8943 5.72452 18.8861 5.72452C18.8779 5.72452 18.8697 5.72041 18.8656 5.72041C18.8532 5.7163 18.845 5.7163 18.8327 5.7163C18.8286 5.7163 18.8245 5.71219 18.8162 5.71219L4.84904 3.78441V1.83607C4.84904 1.81552 4.84904 1.79497 4.84493 1.77852C4.84493 1.77441 4.84493 1.7703 4.84082 1.76208C4.84082 1.74975 4.83671 1.73742 4.83671 1.72509C4.8326 1.71276 4.8326 1.70454 4.82849 1.69221C4.82849 1.68399 4.82438 1.67987 4.82438 1.67165C4.82027 1.65932 4.81616 1.64699 4.81205 1.63466C4.81205 1.63055 4.80794 1.62233 4.80794 1.61822C4.80383 1.60589 4.79972 1.59767 4.7915 1.58534C4.78739 1.58122 4.78739 1.573 4.78328 1.56889C4.77917 1.56067 4.77506 1.55245 4.76684 1.54423C4.76273 1.53601 4.75862 1.5319 4.7545 1.52368C4.75039 1.51546 4.74628 1.51135 4.74217 1.50313C4.73806 1.49491 4.72984 1.48669 4.72573 1.47846C4.72162 1.47435 4.71751 1.47024 4.7134 1.46613C4.70518 1.45791 4.69696 1.44969 4.68874 1.44147C4.68463 1.43736 4.68052 1.43325 4.67641 1.42914C4.66819 1.42092 4.65997 1.4127 4.64763 1.40448C4.64352 1.40037 4.6353 1.39626 4.63119 1.39215C4.62297 1.38392 4.61475 1.37981 4.60653 1.37159C4.5942 1.36337 4.58187 1.35515 4.57365 1.35104C4.56954 1.34693 4.56543 1.34693 4.56132 1.34282C4.54487 1.3346 4.52432 1.32638 4.50788 1.31816L1.4785 0.0439301C1.19489 -0.075272 0.870163 0.0562613 0.750961 0.33988C0.631759 0.623498 0.763293 0.948221 1.04691 1.06742L3.73512 2.2019V4.71747V5.11618V8.17433V10.9078V14.3605C3.73512 15.5114 4.59831 16.465 5.71223 16.6089C5.51082 16.946 5.39162 17.3406 5.39162 17.7598C5.39162 18.997 6.39867 20 7.63179 20C8.86492 20 9.87197 18.9929 9.87197 17.7598C9.87197 17.3488 9.76099 16.9583 9.56369 16.6295H14.5537C14.3564 16.9624 14.2455 17.3488 14.2455 17.7598C14.2455 18.997 15.2525 20 16.4856 20C17.7188 20 18.7258 18.9929 18.7258 17.7598C18.7258 16.5267 17.7188 15.5196 16.4856 15.5196H6.00407C5.36285 15.5196 4.84493 14.9976 4.84493 14.3605V12.8561C5.18199 13.0534 5.5807 13.1685 6.00407 13.1685ZM8.76627 17.7557C8.76627 18.3805 8.25658 18.8861 7.6359 18.8861C7.01523 18.8861 6.50554 18.3764 6.50554 17.7557C6.50554 17.135 7.01523 16.6253 7.6359 16.6253C8.25658 16.6253 8.76627 17.1309 8.76627 17.7557ZM17.6201 17.7557C17.6201 18.3805 17.1104 18.8861 16.4897 18.8861C15.8691 18.8861 15.3594 18.3764 15.3594 17.7557C15.3594 17.135 15.8691 16.6253 16.4897 16.6253C17.1104 16.6253 17.6201 17.1309 17.6201 17.7557ZM17.0241 12.0587H6.00407C5.36285 12.0587 4.84493 11.5366 4.84493 10.8995V8.16611V5.10796V4.90244L18.1832 6.73979V10.8954C18.1832 11.5408 17.6612 12.0587 17.0241 12.0587Z"
                fill="#FFFCF9" />
            </svg> &nbsp;Add to Cart
            </submit-button>
        </div>
        
        </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: ['farm'],
    data() {
        return {

        }
    },
    computed: {
        ...mapState(['states']),
        ...mapState('offtaker', ['cart']),
        getState() {
            const state = this.farm ? this.states.find(item => item.id === this.farm.farm.state_id) : ''
            return state;
        },
        
        checkKg() {
            if((this.farm.kg_yield - this.farm.kg_sold) === 0) {
                return true;
            }
            // if((this.farm.kg_yield - this.farm.kg_sold - (this.checkCartQty * 1000)) === 0) {
            //     return true;
            // }
            return false;
        },
        checkCartQty() {
            if(this.cart.length !== 0) {
            const arr = this.cart.filter(item => item.id === this.farm.id)
            const total = arr.reduce((sum, item) => {
                return sum + Number(item.quantity)
            }, 0)
                return total;
            } else {
                return 0
            }
        }
    },
    methods: {
        linkToDetails() {
            this.$router.push({
                name: 'offtaker.crop',
                params: {
                    id: this.farm.id
                }
            })
        },
        addToCart() {
            this.$emit('farmItem', this.farm)
            window.$('#newOrder').modal('show')
        }
    } 
}
</script>

<style>

</style>